import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './contexts/StripeContext';
import HomePage from "./pages/HomePage";
import WalkListPage from "./pages/WalkListPage";
import WalkDetailPage from "./pages/WalkDetailPage";
import FavoritesPage from "./pages/FavoritesPage";
import AboutPage from "./pages/AboutPage";
import SubmitWalkPage from "./pages/SubmitWalkPage";
import ContactPage from "./pages/ContactPage";
import GearListPage from "./pages/GearListPage";
import GearDetailPage2 from "./pages/GearDetailPage2";
import MembershipPage from "./pages/MembershipPage";
import PartnershipsPage from "./pages/PartnershipsPage";
import JournalGalleryPage from "./pages/JournalGalleryPage";
import OfflineManager from "./pages/OfflineManager";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import BillingPage from "./pages/BillingPage";
import LiveTrackingPage from "./pages/LiveTrackingPage";
import SavedWalksPage from "./pages/SavedWalksPage";
import WalkingTipsPage from "./pages/WalkingTipsPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import AccountSettingsPage from "./pages/AccountSettingsPage";
import CompletionsPage from "./pages/CompletionsPage";

// CMS Pages
import CMSDashboard from "./pages/CMSDashboard";
import AdvancedCMSDashboard from "./pages/AdvancedCMSDashboard";
import CMSWalkManagement from "./pages/CMSWalkManagement";
import CMSWalkForm from "./pages/CMSWalkForm";
import CMSUserManagement from "./pages/CMSUserManagement";
import CMSMediaLibrary from "./pages/CMSMediaLibrary";
import CMSBulkImport from "./pages/CMSBulkImport";
import CMSGearPage from "./pages/CMSGearPage";
import CMSBulkGeneratePage from "./pages/CMSBulkGeneratePage";

import { Helmet } from 'react-helmet-async';
import { generateWebSiteSchema } from './utils/seoData';
import { Toaster } from "./components/ui/toaster";

// Component to handle scroll to top on route change
function ScrollToTop() {
  const location = useLocation();
  
  useEffect(() => {
    // Only scroll to top for main route changes, not query parameter changes
    const pathChanged = !location.search || location.pathname !== location.pathname;
    if (pathChanged) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <StripeProvider>
          <Helmet>
            <script type="application/ld+json">
              {JSON.stringify(generateWebSiteSchema())}
            </script>
          </Helmet>
          <div className="App">
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/walks" element={<WalkListPage />} />
                <Route path="/walks/:country" element={<WalkListPage />} />
                <Route path="/walks/:country/:city" element={<WalkListPage />} />
                <Route path="/walks/:country/:city/:neighborhood" element={<WalkListPage />} />
                <Route path="/walks/:country/:city/:neighborhood/:slug" element={<WalkDetailPage />} />
              <Route path="/favorites" element={<FavoritesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/submit" element={<SubmitWalkPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/gear" element={<GearListPage />} />
              <Route path="/gear/:slug" element={<GearDetailPage2 />} />
              <Route path="/membership" element={<MembershipPage />} />
              <Route path="/partnerships" element={<PartnershipsPage />} />
              <Route path="/journals" element={<JournalGalleryPage />} />
              <Route path="/offline" element={<OfflineManager />} />
              <Route path="/analytics" element={<AnalyticsDashboard />} />
              <Route path="/tracking/live" element={<LiveTrackingPage />} />
              <Route path="/tracking/saved" element={<SavedWalksPage />} />
              <Route path="/billing" element={<BillingPage />} />
              <Route path="/tips" element={<WalkingTipsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/account/settings" element={<AccountSettingsPage />} />
              <Route path="/account/completions" element={<CompletionsPage />} />
              
              {/* CMS Routes */}
              <Route path="/cms" element={<CMSDashboard />} />
              <Route path="/cms/dashboard" element={<CMSDashboard />} />
              <Route path="/cms/advanced" element={<AdvancedCMSDashboard />} />
              <Route path="/cms/walks" element={<CMSWalkManagement />} />
              <Route path="/cms/walks/create" element={<CMSWalkForm />} />
              <Route path="/cms/walks/bulk-import" element={<CMSBulkImport />} />
              <Route path="/cms/walks/:id/edit" element={<CMSWalkForm />} />
              <Route path="/cms/users" element={<CMSUserManagement />} />
              <Route path="/cms/media" element={<CMSMediaLibrary />} />
              <Route path="/cms/gear" element={<CMSGearPage />} />
              <Route path="/cms/bulk-generate" element={<CMSBulkGeneratePage />} />
              <Route path="/cms/bulk-generate/:campaignId" element={<CMSBulkGeneratePage />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </div>
      </StripeProvider>
    </AuthProvider>
  </HelmetProvider>
  );
}

export default App;